import React, { Dispatch, FC, SetStateAction } from 'react'
import './packet.scss'
import { plusIcon } from 'assets'
import { CounterButton } from 'components/counterButton/CounterButton'
import { SelectedPacket } from 'components/enrollForm/enrollFormTypes'
import { numberFormatter, constants } from 'helpers'
import { colors } from 'styles/colors'
import { usePacketSelection } from '../../hooks/usePacketSelection'

type PackageProps = {
    productPacket: SelectedPacket
    quantity: number
    packetSelectionHandler: Dispatch<SetStateAction<SelectedPacket[]>>
}

export const Packet: FC<PackageProps> = ({
    productPacket,
    quantity,
    packetSelectionHandler
}) => {
    const {
        counter,
        setCounter,
        showCounterButton,
        selectedPacket,
        packetRef,
        price,
        sizeDisplay,
        size,
        handlePacketSelection
    } = usePacketSelection({
        productPacket,
        quantity,
        packetSelectionHandler
    })

    return (
        <div className="package--parent" ref={packetRef}>
            <div className="package--main-parent">
                <div
                    className={`package--main ${
                        selectedPacket ? 'package--main-selected' : ''
                    }`.trim()}
                    data-testid={`package--main--${size}`}
                    onClick={() => {
                        handlePacketSelection()
                    }}
                >
                    <h2
                        className="package--size"
                        aria-label="package-size-text"
                    >
                        {sizeDisplay}
                    </h2>
                </div>
                {showCounterButton ? (
                    <div className="package--counter">
                        <CounterButton
                            count={counter}
                            onCountChange={setCounter}
                            maxCount={constants.MAX_ORDER_OF_PACKAGE}
                        />
                    </div>
                ) : counter > 0 ? (
                    <div className="package--quantity package--container-bottom-right">
                        <p className="package--quantity-text">{counter}</p>
                    </div>
                ) : (
                    <div
                        onClick={handlePacketSelection}
                        className="package--add-icon package--container-bottom-right"
                    >
                        {plusIcon({
                            color: colors.veryDarkGreen,
                            width: '16',
                            height: '16'
                        })}
                    </div>
                )}
            </div>
            <div className="package--price-parent">
                <p className="package--price">{numberFormatter(price)}</p>
            </div>
        </div>
    )
}
